<template>
	<app-page>
		<app-heading :title="isNew ? 'New String' : str.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: prevRoute }">Cancel</app-button>
				</app-section-actions>
				<input-combobox
					label="Namespace"
					:items="namespaces"
					v-model="str.namespace"
					required
					:errors="errors.namespace"
				/>
				<input-combobox
					label="Category"
					:items="categories"
					v-model="str.category"
					required
					:errors="errors.category"
				/>
				<input-text
					label="Slug"
					v-model="str.slug"
					required
					:errors="errors.slug"
				/>
				<div
					v-for="(locale, i) in locales"
					:key="`locale-${i}`"
				>
					<div>{{locale | locale}}</div>
					<input-textarea
						placeholder="Type some text...."
						v-model="str.text[locale]"
						required
						:errors="errors.text"
					/>
				</div>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
import websiteItemParentMixin from '@/mixins/websiteitemparent'

export default {
	mixins: [websiteItemParentMixin],
	data() {
		return {
			namespaces: [],
			categories: [],
			locales: [],
			str: {
				slug: '',
				namespace: null,
				category: null,
				text: {},
			},
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.string
		},
		isNew() {
			return this.id === 'new'
		},
		prevRoute() {
			return this.isTemplate ? 'website-template-strings' : 'website-strings'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.str = await this.$ravello.request()
					.v(2)
					.to(this.parentEndpoint)
					.to(this.parentId)
					.to('strings')
					.to(this.id)
					.get()
			}
			const [namespaces, categories, parent] = await Promise.all([
				this.$ravello.request()
					.v(2)
					.to(this.parentEndpoint)
					.to(this.parentId)
					.to('namespaces')
					.dataSource(),
				this.$ravello.request()
					.v(2)
					.to('stringcategories')
					.dataSource(),
				this.$ravello.request()
					.v(2)
					.to(this.parentEndpoint)
					.to(this.parentId)
					.field('locales')
					.get(),
			])

			this.namespaces = namespaces
			this.categories = categories
			this.locales = parent.locales || []

			this.locales.forEach((locale) => {
				if (!this.str.text[locale]) {
					this.str.text[locale] = ''
				}
			})
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			const payload = {
				slug: this.str.slug,
				namespace: this.str.namespace,
				category: this.str.category,
				text: this.str.text,
			}

			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to(this.parentEndpoint)
						.to(this.parentId)
						.to('strings')
						.create(payload)
				} else {
					await this.$ravello.request()
						.v(2)
						.to(this.parentEndpoint)
						.to(this.parentId)
						.to('strings')
						.to(this.id)
						.update(payload)
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `String successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: this.prevRoute })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
